import { type FC, useState } from "react";
import { useApi } from "../api/APIContext";
import { useApiCall, ValidationError } from "../api/api";
import type { Company } from "../api/dto";
import { Autocomplete } from "../components/form/Autocomplete";
import { Input } from "../components/form/Input";
import { ModalFooter } from "../components/layout/ModalProvider";
import { useRefresh } from "../components/RefreshController";

export const AddProjectModal: FC<{ company?: Company | null }> = (props) => {
  const { companies } = useApi();
  const { addProject } = useApiCall();
  const refresh = useRefresh();
  const [name, setName] = useState<string>("");
  const [company, setCompany] = useState<string>(props.company ? props.company.id : "");
  const [errors, setErrors] = useState<string[]>([]);
  const companyMap = companies.filter((c) => !c.isArchived).map((c) => [c.id, c.name]);
  const selectedCompany = companies.find((c) => c.id === company);

  const save = async () => {
    await addProject(company, name).catch((e) => {
      if (e instanceof ValidationError) {
        setErrors(Object.values(e.errors).flat());
      }
      throw e;
    });
    refresh();
  };
  return (
    <div className={""}>
      <div className={"min-h-[calc(220px+4rem)] flex-col space-y-3"}>
        <Autocomplete
          label={"Bedrijf"}
          value={company}
          options={Object.fromEntries(companyMap)}
          onChange={(c) => {
            setCompany(c);
          }}
        />
        <Input type={"text"} label={"Project naam"} value={name} onChange={setName} />
      </div>
      <ModalFooter text={"Opslaan"} onSubmit={save} />
    </div>
  );
};
